import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";
import React, { useState } from "react";
import { Link } from "react-router-dom";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function PhoneNavDropdown(props) {
  const [selectedItemName, setSelectedItemName] = useState(props.title); // String shown in button of dropdown
  const [render, setRender] = useState(true);

  function setCurrentItem(item) {
    setSelectedItemName(item.name);
    setRender(!render);
  }

  var items = props.items.map((item) => (
    <Menu.Item key={item.name}>
      {({ active }) => (
        <Link
          to={item.href}
          className={classNames(
            active ? "bg-gray-100 text-gray-900" : "text-gray-700",
            "block px-4 py-2 text-sm "
          )}
          onClick={() => setCurrentItem(item)}
        >
          {item.name}
        </Link>
      )}
    </Menu.Item>
  ));
  return (
    <Menu
      as="div"
      className="relative inline-block text-left  w-24 "
      style={{ zIndex: props.z }}
    >
      {({ open }) => (
        <>
          <div>
            <Menu.Button className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-600">
              {selectedItemName}
              <ChevronDownIcon
                className="-mr-1 ml-2 h-5 w-5"
                aria-hidden="true"
              />
            </Menu.Button>
          </div>

          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              static
              className="origin-top-right absolute mt-2 w-full rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
            >
              <div className="py-1">{items}</div>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
}
